import React, { useState, useMemo } from "react";

import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import { TextField, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import './ServicesDashboard.css';

import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RefreshIcon from "@mui/icons-material/Refresh";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function ServicesDashboard() {
    const [selectedIds, setSelectedIds] = useState([]);
    const [editService, setEditService] = useState(null);


    const theme = useTheme();

    const services = [
        { id: 1, imageUrl: "images/conct2.png", title: "Assurance & Business Consultancy", text: "Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy.Financial assurance and management consultancy." },
        { id: 2, imageUrl: "images/conct2.png", title: "Tax Advisory Services", text: "Corporate and personal tax advisory and compliance." },
        { id: 3, imageUrl: "images/conct2.png", title: "Corporate Secretarial Services", text: "Company secretarial matters including incorporations and annual returns." },
        { id: 4, imageUrl: "images/conct2.png", title: "Business Process Reengineering", text: "Reengineering business processes to meet modern best practices." },
        { id: 5, imageUrl: "images/conct2.png", title: "HR Management and Payroll Services", text: "Handling payroll and HR functions while you focus on business." },
        { id: 6, imageUrl: "images/conct2.png", title: "Inventory Verifications", text: "Periodisstock verification with expert reporting for management." },
        { id: 7, imageUrl: "images/conct2.png", title: "Management Consultancy", text: "Providing expert management consultancy services." },
        { id: 8, imageUrl: "https://vtas-web.s3.eu-north-1.amazonaws.com/images/ITBNM-2110-0002+-+Tharoon+Naveedya+-+Wireless+Networking.png", title: "Book Keeping Services", text: "Accurate daily transaction records and reliable financial reports." },
    ];



    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEditService(null);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const email = formJson.email;
        console.log(email);
        handleClose();
    };

    const editSelectedService = (e, service) => {
        e.stopPropagation();
        setEditService({
            ...service,
            existingImage: service.imageUrl,
            newImageFile: null,
            newImagePreview: null,
        });
        setOpen(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);

        setEditService(prev => ({
            ...prev,
            newImageFile: file,
            newImagePreview: previewUrl,
        }));
    };



    const handleCheckboxChange = (id) => {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]
        );
    };

    const selectAllServices = () => {
        const allSelected = services.every(s => selectedIds.includes(s.id));

        if (allSelected) {
            setSelectedIds([]);
        } else {
            setSelectedIds(services.map(s => s.id));
        }
    };
    function ReadMore({ title, text, maxLength = 20 }) {
        const [isExpanded, setIsExpanded] = useState(false);

        return (
            <div style={{ position: "relative", textAlign: "center" }}>

                {!isExpanded && (
                    <span>
                        {text.substring(0, maxLength)}
                        {text.length > maxLength ? "... " : ""}
                    </span>
                )}

                {text.length > maxLength && !isExpanded && (
                    <Button
                        variant="text"
                        size="small"
                        sx={{ textTransform: "none", padding: 0, minWidth: 0 }}
                        onClick={() => setIsExpanded(true)}
                    >
                        Read more
                    </Button>
                )}

                {/* Overlay */}
                {isExpanded && (
                    <div
                        className="readmore-overlay"
                    >
                        <div style={{ fontWeight: 600, marginBottom: 8 }}>
                            {title}
                        </div>

                        <div style={{ fontSize: "12px", lineHeight: 1.5 }}>
                            {text}
                        </div>

                        <div style={{ textAlign: "right", marginTop: 8 }}>
                            <Button
                                variant="text"
                                size="small"
                                onClick={() => setIsExpanded(false)}
                                sx={{ textTransform: "none", padding: 0, minWidth: 0 }}
                            >
                                Close
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }



    return (
        <div className="service-container">
            <>
                <div className="service-header">
                    <div>
                        <h4 style={{ fontWeight: "Bold", paddingBottom: 0, marginBottom: 0, paddingTop: "8px", color: "#0098f0ff" }}>
                            Services
                        </h4>
                    </div>

                    <div>
                        <Tooltip title="Refresh">
                            <IconButton
                                sx={{
                                    // color: "rgba(0, 0, 0, 0.7)",
                                    "&:hover": {
                                        color: "#2091e7ff",
                                        backgroundColor: "transparent",
                                    },
                                }}
                            > <RefreshIcon /></IconButton>
                        </Tooltip>
                        <Tooltip title="Select All">
                            <IconButton
                                sx={{
                                    // color: "rgba(0, 0, 0, 0.7)",
                                    "&:hover": {
                                        color: "#2091e7ff",
                                        backgroundColor: "transparent",
                                    },
                                }}
                                onClick={() => selectAllServices()}
                            > <ChecklistRtlIcon /></IconButton>
                        </Tooltip>

                        <Tooltip title="Delete">
                            <IconButton
                                sx={{
                                    // color: "rgba(0, 0, 0, 0.7)",
                                    "&:hover": {
                                        color: "red",
                                        backgroundColor: "transparent",
                                    },
                                }}
                            > <DeleteForeverIcon /></IconButton>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    padding: 10, borderRadius: 8, display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)", gridAutoRows: "1fr", textAlign: "center", gap: 15
                }}>
                    {services.map(service => (
                        <div
                            key={service.id}
                            className="services-card"
                        >
                            <img src={service.imageUrl}
                                alt={service.title} width="150"
                                height="150"
                                style={{ border: "1px solid black", objectFit: "fit", borderRadius: 8 }} />
                            <div style={{ paddingTop: 8 }}>
                                <div><strong> {service.title}</strong></div>
                                <div style={{ fontSize: "12px", textAlign: "center", marginTop: 4 }}>
                                    <ReadMore
                                        title={service.title}
                                        text={service.text}
                                        maxLength={200}
                                    />
                                </div>
                            </div>
                            <div className="card-actions">
                                <Checkbox

                                    checked={selectedIds.includes(service.id)}
                                    onClick={e => e.stopPropagation()} // prevent card click
                                    onChange={() => handleCheckboxChange(service.id)}
                                    title="Select"
                                />
                                <div className="hover-actions">
                                    <IconButton
                                        sx={{
                                            "&:hover": {
                                                color: "#2091e7ff",
                                                backgroundColor: "transparent",
                                            },
                                        }}
                                        onClick={(e) => editSelectedService(e, service)}
                                        title="Edit"
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>

                                    <IconButton
                                        sx={{
                                            "&:hover": {
                                                color: "red",
                                                backgroundColor: "transparent",
                                            },
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                        title="Delete"
                                    >
                                        <DeleteForeverIcon />
                                    </IconButton>
                                </div>


                            </div>
                        </div>

                    ))}

                    {/* Add New services */}
                    <div
                        key={1000}
                        onClick={handleClickOpen}
                        className="add-service-card"
                    >
                        <AddIcon fontSize="large" />
                        <div style={{ paddingTop: 8 }}>
                            <div><strong> Add a New service </strong></div>
                        </div>
                    </div>
                </div>
            </>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle align="center" fontWeight="bold"> Add a New service </DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit} id="add-services-form">

                       
                        {(editService?.newImagePreview || editService?.existingImage) && (
                            <div className="edit-image">
                                <img
                                    src={editService.newImagePreview || editService.existingImage}
                                    alt="Service"
                                    className="service-image"
                                />

                                <div className="image-overlay">
                                    <IconButton
                                        component="label"
                                        sx={{
                                            color: "#006da0ff",
                                            "&:hover": {
                                                backgroundColor: "rgba(0,0,0,0.8)",
                                            },
                                        }}
                                    >
                                        <EditIcon />
                                        <input
                                            type="file"
                                            hidden
                                            accept="image/*"
                                            onChange={handleImageChange}
                                        />
                                    </IconButton>
                                </div>
                            </div>
                        )}

                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="title"
                            label="Title"
                            variant="outlined"
                            fullWidth
                            value={editService?.title || ""}
                            onChange={(e) =>
                                setEditService({
                                    ...editService,
                                    title: e.target.value,
                                })
                            }
                        />
                        <TextField
                            autoFocus
                            required
                            margin="dense"
                            id="text"
                            label="Description"
                            variant="outlined"
                            multiline
                            rows={6}
                            fullWidth
                            value={editService?.text || ""}
                            onChange={(e) =>
                                setEditService({
                                    ...editService,
                                    text: e.target.value,
                                })
                            }

                        />
                                    <TextField
                                      autoFocus
                                      required
                                      margin="dense"
                                      id="company-logo"
                                      label="Insert Image"
                                      type="file"
                                      variant="outlined"
                                      fullWidth
                                      InputLabelProps={{ shrink: true }}
                                      
                                    />

                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit" form="add-services-form">
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>


    );
}
